export class LocaleChanged {
  constructor(code) {
    this.code = code;
  }
}
